import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const networks = [
  { name: 'Instagram', icon: FiIcons.FiInstagram },
  { name: 'TikTok', icon: FiIcons.FiVideo },
  { name: 'LinkedIn', icon: FiIcons.FiLinkedin },
  { name: 'Facebook', icon: FiIcons.FiFacebook },
  { name: 'YouTube', icon: FiIcons.FiYoutube },
  { name: 'Threads', icon: FiIcons.FiAtSign },
  { name: 'X (Twitter)', icon: FiIcons.FiTwitter },
  { name: 'Pinterest', icon: FiIcons.FiTarget },
  { name: 'Snapchat', icon: FiIcons.FiGhost },
  { name: 'Reddit', icon: FiIcons.FiHash },
  { name: 'Discord', icon: FiIcons.FiMessageCircle },
  { name: 'Mastodon', icon: FiIcons.FiActivity },
  { name: 'Slack', icon: FiIcons.FiSlack }
];

const BifrostSocialGrid = () => {
  return (
    <section className="py-24 bg-gray-900 text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-extrabold mb-6">
              13 Networks. <br />
              <span className="text-indigo-400">One Integrated Bridge.</span>
            </h2>
            <p className="text-gray-400 text-lg mb-12 leading-relaxed">
              Bifrost isn't just a scheduler—it's a transformation engine. Whether it's a 15-second TikTok or a deep-dive LinkedIn article, Bifrost ensures your event looks native everywhere.
            </p>
            <div className="space-y-8">
              {[
                { id: 1, title: "Email-to-Social Magic", desc: "Found a great update? Just email it to your Bifrost bridge and we'll handle the rest." },
                { id: 2, title: "Automated Resizing", desc: "Upload once. We crop and format for Reels, Stories, and Feeds instantly." },
                { id: 3, title: "Platform Compliance", desc: "No more rejected posts. We stay updated with API changes so you don't have to." }
              ].map((step) => (
                <div key={step.id} className="flex items-start">
                  <div className="flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-full bg-indigo-600 text-white font-bold border-2 border-indigo-500">
                    {step.id}
                  </div>
                  <div className="ml-6">
                    <h4 className="text-xl font-bold text-white mb-2">{step.title}</h4>
                    <p className="text-gray-400">{step.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          <div className="relative">
            <div className="grid grid-cols-3 sm:grid-cols-4 gap-4">
              {networks.map((net, i) => (
                <div key={i} className="bg-gray-800/50 backdrop-blur-sm border border-gray-700 p-6 rounded-2xl flex flex-col items-center justify-center gap-3 hover:border-indigo-500 hover:bg-gray-800 transition-all group">
                  <SafeIcon icon={net.icon} className="w-8 h-8 text-gray-400 group-hover:text-indigo-400 transition-colors" />
                  <span className="text-[10px] font-bold uppercase tracking-widest text-gray-500 group-hover:text-white">{net.name}</span>
                </div>
              ))}
            </div>
            {/* Background Glow */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-indigo-600/20 blur-[100px] -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BifrostSocialGrid;